import Vue from 'vue'
import VueRouter from 'vue-router'
import ShopList from '../views/ShopList.vue'
import CjIndex from '../views/CjIndex.vue'
import Login from '../views/Login.vue'
import MenuMain from '../views/MenuMain.vue'
import PickQu  from '../views/PickQu.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'login',
    component: Login
  },
  {
    path: '/shoplist',
    name: 'shoplist',
    component: ShopList
  },
  {
    path: '/cjIndex',
    name:'cjIndex',
    component: CjIndex,
    children:[
      {
        path:"",
        name:"mainp",
        component: MenuMain
      },{
        path:"pickqu",
        name: "pickqu",
        component: PickQu,
      }
    ]
  },
]

const router = new VueRouter({
  routes
})

export default router
